import { render, staticRenderFns } from "./IconElo.vue?vue&type=template&id=27e54450&"
import script from "./IconElo.vue?vue&type=script&lang=ts&"
export * from "./IconElo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports